var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVoiceIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.8 20.0001V15.9001L10.7 16.1001C11.2531 16.0693 11.7766 15.84 12.1742 15.4542C12.5717 15.0684 12.8167 14.552 12.864 14.0001V8.30008C12.8706 6.85942 12.3047 5.47513 11.2907 4.45175C10.2767 3.42836 8.89766 2.84971 7.457 2.84308C6.01634 2.83644 4.63206 3.40238 3.60867 4.41639C2.58529 5.4304 2.00663 6.80942 2 8.25008C2 11.0501 2.656 11.3041 3 12.8001C3.23248 13.7035 3.24243 14.6499 3.029 15.5581L2 20.0001M19.8 17.8C21.2059 16.394 21.9959 14.4874 21.9964 12.4991C21.997 10.5109 21.2081 8.6038 19.803 7.19702M17.0001 14.9999C17.3273 14.6728 17.5863 14.2841 17.7623 13.8562C17.9383 13.4283 18.0278 12.9698 18.0254 12.5072C18.0231 12.0445 17.9291 11.587 17.7488 11.1609C17.5685 10.7348 17.3055 10.3487 16.9751 10.0249",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgVoiceIcon;